import React from 'react'
import {
  styled,
  Content,
  Italic,
  BoxProps,
  LinkInternal,
  Rows,
  Columns,
} from '../../design-system'
import { PartnerGrid, ProfilePicture } from '../atoms'
import { Event } from '../../domain/event'

interface ProgrammeCellProps {
  event: Event
}

const Wrapper = styled(Rows.withComponent(LinkInternal))`
  cursor: pointer;
  border-top: 2px solid ${({ theme }) => theme.color('contentAlt')};
`

export const ProgrammeCell = ({ event }: ProgrammeCellProps) => {
  return (
    <Wrapper
      justifyContent="flex-start"
      to={Event.getPagePath(event)}
      className="programme-cell"
      maxWidth="100%"
    >
      <ProfilePicture
        height={{ mobile: '214px', tablet: '300px' }}
        src={event.imageUrl}
      />
      <Rows flexGrow={1} spacing={1}>
        <Columns wrap justifyContent="space-between" alignItems="baseline">
          <Content color="contentAlt" variant="panelCaption">
            {event.formatName}
            {event.venueName && (
              <>
                {' • '}
                <Italic>{event.venueName}</Italic>
              </>
            )}
          </Content>
          {event.timings && (
            <Content color="contentAlt" variant="panelCaption">
              {event.timings.formatStart('ddd DD.MM.YYYY')}
            </Content>
          )}
        </Columns>
        <Content variant="panelTitle" color="contentAlt">
          {event.name}
        </Content>
        {event.speakerNames.length > 0 && (
          <Content variant="panelBody">
            With {event.speakersDescription}
          </Content>
        )}
      </Rows>
    </Wrapper>
  )
}

export const ProgrammeGrid = (props: BoxProps) => (
  <PartnerGrid
    gap={3}
    justifyContent="start"
    alignContent="start"
    justifyItems="stretch"
    alignItems="stretch"
    columnSize={{ mobile: 250, tablet: 320, desktop: 350 }}
    fillMode="auto-fill"
    {...props}
  />
)
